@if (isReady) {
	<router-outlet></router-outlet>
} @else {
	<div class="app-bootstrap-loading">
		<div class="app-bootstrap-notice" [class.is-error]="bootstrapMessageIsError">
			<p class="app-bootstrap-message">{{ bootstrapMessage }}</p>
		</div>
	</div>
}
